export const formatString4Class = (str : string) => {

	// replace all spaces with - and make lowercase
	return str.replace(/\s+/g, '-').toLowerCase()
}